import { c as _c } from "react-compiler-runtime";
import { useContext } from 'react';
// @ts-ignore untyped JS module
import formatFraction from '../utils/formatFraction';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
function FormattedFraction(t0) {
  const $ = _c(5);
  const {
    numerator,
    denominator
  } = t0;
  useContext(I18nHMRContext);
  let t1;
  if ($[0] !== denominator || $[1] !== numerator) {
    t1 = formatFraction({
      numerator,
      denominator
    });
    $[0] = denominator;
    $[1] = numerator;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = /*#__PURE__*/_jsx("span", {
      children: t1
    });
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
FormattedFraction.displayName = 'FormattedFraction';
export default FormattedFraction;